const noop = Function.prototype;

export default (typeof window === 'object' && window.metrics) || {
  init: noop,
  view: noop,
  link: noop,
};

// Wrapper for the global metrics
export const metricsWrapper =
  typeof window !== 'undefined' && window.metrics
    ? window.metrics
    : {
        link: () => null,
        view: () => null,
      };

// Handler for a global listener to capture data-analytics-id clicks
export const metricsOnGlobalClick = (e) => {
  const closestParent = e.target.closest('[data-analytics-id]');
  const linkName = e.target?.dataset?.analyticsId || closestParent?.dataset?.analyticsId;

  if (linkName) {
    metricsWrapper.link({ linkName });
  }
};
